<template>
  <div
    class="mx-auto flex h-dvh max-w-360 min-w-112 flex-col gap-y-[clamp(0.25rem,0.75vh,0.75rem)] p-2 pb-4"
  >
    <slot name="header" />
    <slot />
  </div>
</template>
